import { constructAsync } from '../../../webmodule-common/other/async-constructor';
import { customElement, state } from 'lit/decorators.js';
import { disposeOf } from '../../../webmodule-common/other/dispose';
import { FranchiseeView } from '../../franchisee/view/franchisee-view';
import { html } from 'lit';
import { TabbedPageBase } from './helpers/page-base';
import { tlang } from '../../../webmodule-common/other/language/lang';
import { userDataStore } from '../common/current-user-data-store';

@customElement('app-settings')
export class AppSettings extends TabbedPageBase {
  @state()
  franchiseeView: FranchiseeView | null = null;

  constructor() {
    super();
  }

  render() {
    if (!this.loggedIn) return html``;
    return html` <div class="page-content">
      <div class="page-container">${this.franchiseeView}</div>
    </div>`;
  }

  meta() {
    return {
      title: tlang`%%franchisee%%`,
      description: tlang`%%franchisee%% settings page`
    };
  }

  protected async canLeavePage(): Promise<boolean> {
    if (this.franchiseeView) return await this.franchiseeView.canClose();
    else return true;
  }

  protected createRenderRoot(): HTMLElement | DocumentFragment {
    return this;
  }

  protected async franchiseeInformationFactory(): Promise<FranchiseeView> {
    return await constructAsync(new FranchiseeView());
  }
  async dispose() {
    await super.dispose();
    await disposeOf(this.franchiseeView);
    this.franchiseeView = null;
  }
  protected async setActiveTabByHash() {
    await this.franchiseeView?.setActiveTabByHash();
  }
  protected async afterUserConnected() {
    //we need to flush the user data store any time we come to this page in case it is stale information
    //switch to clear. this is causing problems in the main UI by leaving things in an unloaded state.
    await userDataStore.reLoadFranchisee();
    this.franchiseeView = await this.franchiseeInformationFactory();
    await super.afterUserConnected();
  }
}
